<!-- rates table -->
<section id="currency-rates" class="max-w-[1160px] mx-auto">
  <header class="text-center mb-24">
    <p class="font-bold">Rates updated at: {{ updatedAt | date: 'EEE yyyy-MM-dd HH:mm' }}</p>
    <hr class="border-2 my-2.5 mx-auto w-64 border-primary" />
    <h2 class="h3-responsive font-bold mt-8">
      <p>We currently support</p>
      <p>the following currencies</p>
    </h2>
  </header>
  <table class="table-fixed w-full mb-10">
    <thead>
      <tr class="lh-50px">
        <th colspan="2"></th>
        <th colspan="5"></th>
        <th class="text-[#459fe4] text-xs sm:h5-responsive 2xl:text-base" colspan="6">WE SELL</th>
        <th class="text-[#459fe4] text-xs sm:h5-responsive 2xl:text-base" colspan="6">WE BUY</th>
      </tr>
    </thead>
    <tbody>
      <!-- rates loop -->
      @for (rate of rates; track $index; let last = $last) {
        <!-- summarized -->
        @if (!rate.summarized) {
          <tr class="lh-90px align-middle" [ngClass]="{ 'border-b-2 border-primary border-solid': !last }">
            <!-- flag image -->
            <td class="align-middle text-center" colspan="2">
              <span class="fi {{ rate.flag }}"></span>
            </td>
            <!-- currency info -->
            <td colspan="5">
              <div class="flex ml-2 sm:ml-0 items-center">
                <p class="font-bold text-xs sm:h5-responsive 2xl:text-[32px] lh-20px">
                  {{ rate.currency }}
                  <!-- mobile mode -->
                  <small class="text-xxs font-normal block sm:hidden"> ({{ rate.description }}) </small>
                </p>
                <!-- desktop mode -->
                <small class="ml-4 text-xs hidden sm:block"> ({{ rate.description }}) </small>
              </div>
            </td>
            <!-- WE SELL -->
            <td colspan="6">
              <currency-rate-cell [rate]="rate" [trade]="'sell'">
                @if (rate.currency) {
                  <alert-button class="self-center" [fromCurrency]="rate.currency" [tradeType]="'sell'" [rate]="rate"></alert-button>
                }
              </currency-rate-cell>
            </td>
            <!-- WE BUY -->
            <td colspan="6">
              <currency-rate-cell [rate]="rate" [trade]="'buy'">
                @if (rate.currency) {
                  <alert-button class="self-center" [fromCurrency]="rate.currency" [tradeType]="'buy'" [rate]="rate"></alert-button>
                }
              </currency-rate-cell>
            </td>
          </tr>
        }
        <!-- end if -->
      }
      <!-- end loop -->
    </tbody>
  </table>
  <!-- summarized rates section -->
  @if (existSummarizedRate) {
    <div class="mb-6 flex items-center">
      For other currency rates, including
      @for (rate of rates; track $index; let last = $last) {
        @if (rate.summarized) {
          <span class="flex mr-0.5"> <span class="!w-8 mx-0.5" [ngClass]="rate.flag"></span> {{ rate.currency }} <span>,</span> </span>
        }
      }
      ..., call us.
    </div>
  }

  <footer>
    @if (rateNotes) {
      <div [innerHTML]="rateNotes.data"></div>
    }
  </footer>
</section>
